var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-field-layout",class:_vm.css},[_c('detect-input',{attrs:{"field":_vm.field,"response":_vm.field.response},model:{value:(_vm.field.response.value),callback:function ($$v) {_vm.$set(_vm.field.response, "value", $$v)},expression:"field.response.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }